import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getAuthHeader, serverUrl } from ".";

export const useGetInstructors = () => {
  return useQuery({
    queryKey: ["instructor"],
    queryFn: async () => {
      const response = await axios.get(
        `${serverUrl}/instructor/`,
        getAuthHeader()
      );
      return response.data;
    },
  });
};

export const useCreateInstructor = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (instructor: any) => {
      const response = await axios.post(
        `${serverUrl}/instructor/`,
        instructor,
        getAuthHeader()
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["instructor"] });
    },
  });
};

export const useActivateInstructor = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }: { id: number }) => {
      const response = await axios.post(
        `${serverUrl}/instructor/${id}/activate/`,
        {},
        getAuthHeader()
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["instructor"] });
    },
  });
};

export const usePatchInstructor = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (instructor: any) => {
      const response = await axios.patch(
        `${serverUrl}/instructor/${instructor.id}/`,
        instructor,
        getAuthHeader()
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["instructor"] });
    },
  });
};

export const useInstructorTraining = () => {
  return useQuery({
    queryKey: ["instructor_training"],
    queryFn: async () => {
      const response = await axios.get(
        `${serverUrl}/instructor/training`,
        getAuthHeader()
      );
      return response.data;
    },
  });
};

export const createAttendanceBook = async (id: number) => {
  return await axios({
    method: "GET",
    url: `${serverUrl}/instructor/attendance_book/${id}`,
    responseType: "blob",
    headers: getAuthHeader().headers,
  });
};
